import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TYPPRICE',
  version: 1,
  label: 'Typical Price (HLC/3)',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 92,
  inputs: [],
  outputs: [line('typprice', 'HLC/3', COLOR.blue)],
  talib: { functions: ['TYPPRICE'], expr: 'TYPPRICE(high, low, close)' },
  listed: true,
  tailSafe: true,
  lookback: () => 0,
}
export default def
